var map = {
	"./admin/courses/edit/da.yml": 12835,
	"./admin/courses/edit/en.yml": 75299,
	"./admin/courses/edit/no.yml": 85619,
	"./admin/courses/edit/se.yml": 38710,
	"./admin/schools/edit/da.yml": 10330,
	"./admin/schools/edit/en.yml": 88310,
	"./admin/schools/edit/no.yml": 11942,
	"./admin/schools/edit/se.yml": 24511,
	"./admin/subscriptions/edit/da.yml": 46667,
	"./admin/subscriptions/edit/en.yml": 64699,
	"./admin/subscriptions/edit/no.yml": 50011,
	"./admin/subscriptions/edit/se.yml": 82366,
	"./ckeditor/da.yml": 38879,
	"./ckeditor/editor/da.yml": 43073,
	"./ckeditor/editor/en.yml": 95861,
	"./ckeditor/editor/no.yml": 67281,
	"./ckeditor/editor/se.yml": 5392,
	"./ckeditor/en.yml": 23671,
	"./ckeditor/no.yml": 85687,
	"./ckeditor/se.yml": 52162,
	"./components/admin/layout/da.yml": 99883,
	"./components/admin/layout/en.yml": 81179,
	"./components/admin/layout/menu/da.yml": 16639,
	"./components/admin/layout/menu/en.yml": 1431,
	"./components/admin/layout/menu/menu_content/da.yml": 40885,
	"./components/admin/layout/menu/menu_content/en.yml": 12417,
	"./components/admin/layout/menu/menu_content/no.yml": 77901,
	"./components/admin/layout/menu/menu_content/se.yml": 61412,
	"./components/admin/layout/menu/no.yml": 49655,
	"./components/admin/layout/menu/se.yml": 82338,
	"./components/admin/layout/no.yml": 56027,
	"./components/admin/layout/se.yml": 76446,
	"./components/admin/newsletter_templates/nav/da.yml": 45180,
	"./components/admin/newsletter_templates/nav/en.yml": 54228,
	"./components/admin/newsletter_templates/nav/no.yml": 43880,
	"./components/admin/newsletter_templates/nav/se.yml": 34653,
	"./components/app_layout/da.yml": 21863,
	"./components/app_layout/en.yml": 17103,
	"./components/app_layout/menu/da.yml": 34619,
	"./components/app_layout/menu/en.yml": 52459,
	"./components/app_layout/menu/no.yml": 6923,
	"./components/app_layout/menu/se.yml": 23054,
	"./components/app_layout/no_access/da.yml": 11626,
	"./components/app_layout/no_access/en.yml": 24870,
	"./components/app_layout/no_access/no.yml": 32022,
	"./components/app_layout/no_access/se.yml": 32175,
	"./components/app_layout/se.yml": 97514,
	"./components/audits/table/da.yml": 25070,
	"./components/audits/table/en.yml": 1986,
	"./components/audits/table/no.yml": 6178,
	"./components/audits/table/se.yml": 16691,
	"./components/contents/absolute_container_editor/no.yml": 13903,
	"./components/contents/absolute_container_editor/se.yml": 38074,
	"./components/contents/editor/da.yml": 453,
	"./components/contents/editor/en.yml": 11441,
	"./components/contents/editor/no.yml": 36861,
	"./components/contents/editor/se.yml": 63412,
	"./components/front_layout/side_bar_menu_button/da.yml": 89482,
	"./components/front_layout/side_bar_menu_button/en.yml": 21574,
	"./components/front_layout/side_bar_menu_button/no.yml": 10102,
	"./components/front_layout/side_bar_menu_button/se.yml": 93903,
	"./components/layout/button/da.yml": 84624,
	"./components/layout/button/en.yml": 99888,
	"./components/layout/not_found_page/da.yml": 58584,
	"./components/layout/not_found_page/en.yml": 32840,
	"./components/layout/not_found_page/no.yml": 29132,
	"./components/layout/not_found_page/se.yml": 49241,
	"./components/newsletters/table/da.yml": 14916,
	"./components/newsletters/table/en.yml": 91500,
	"./components/newsletters/table/no.yml": 8976,
	"./components/newsletters/table/se.yml": 95301,
	"./components/plans/sign_up_modal/da.yml": 70969,
	"./components/plans/sign_up_modal/en.yml": 1757,
	"./components/plans/sign_up_modal/no.yml": 65481,
	"./components/plans/sign_up_modal/period_option/da.yml": 35985,
	"./components/plans/sign_up_modal/period_option/en.yml": 60613,
	"./components/plans/sign_up_modal/period_option/no.yml": 99873,
	"./components/plans/sign_up_modal/period_option/se.yml": 3507,
	"./components/plans/sign_up_modal/plan_card/da.yml": 3212,
	"./components/plans/sign_up_modal/plan_card/en.yml": 7812,
	"./components/plans/sign_up_modal/plan_card/no.yml": 80024,
	"./components/plans/sign_up_modal/plan_card/se.yml": 16781,
	"./components/plans/sign_up_modal/se.yml": 4296,
	"./components/plans/table/da.yml": 22528,
	"./components/plans/table/en.yml": 26336,
	"./components/plans/table/no.yml": 15764,
	"./components/plans/table/se.yml": 52353,
	"./components/school_class_check_ins/close_button/da.yml": 88698,
	"./components/school_class_check_ins/close_button/en.yml": 854,
	"./components/school_class_check_ins/close_button/no.yml": 94214,
	"./components/school_class_check_ins/close_button/se.yml": 47519,
	"./components/school_class_roles/change_role_modal/da.yml": 89604,
	"./components/school_class_roles/change_role_modal/en.yml": 91916,
	"./components/school_class_roles/change_role_modal/no.yml": 83011,
	"./components/school_class_roles/change_role_modal/se.yml": 15845,
	"./components/school_class_roles/remove_role_modal/da.yml": 47196,
	"./components/school_class_roles/remove_role_modal/en.yml": 44564,
	"./components/school_class_roles/remove_role_modal/no.yml": 53064,
	"./components/school_class_roles/remove_role_modal/se.yml": 6045,
	"./components/school_classes/admin_card/da.yml": 12109,
	"./components/school_classes/admin_card/en.yml": 70185,
	"./components/school_classes/admin_card/no.yml": 58981,
	"./components/school_classes/admin_card/se.yml": 22780,
	"./components/school_classes/card/da.yml": 83137,
	"./components/school_classes/card/en.yml": 31477,
	"./components/school_classes/card/no.yml": 72049,
	"./components/school_classes/card/se.yml": 83984,
	"./components/school_classes/create_check_in_button/da.yml": 95059,
	"./components/school_classes/create_check_in_button/en.yml": 6643,
	"./components/school_classes/create_check_in_button/no.yml": 51907,
	"./components/school_classes/create_check_in_button/se.yml": 55142,
	"./components/school_classes/delete_modal/da.yml": 26482,
	"./components/school_classes/delete_modal/en.yml": 82526,
	"./components/school_classes/delete_modal/no.yml": 19614,
	"./components/school_classes/delete_modal/se.yml": 27927,
	"./components/school_classes/layout/da.yml": 43209,
	"./components/school_classes/layout/en.yml": 43597,
	"./components/school_classes/layout/no.yml": 26489,
	"./components/school_classes/layout/se.yml": 31736,
	"./components/school_classes/table/da.yml": 34793,
	"./components/school_classes/table/en.yml": 26829,
	"./components/school_classes/table/no.yml": 1945,
	"./components/school_classes/table/se.yml": 12696,
	"./components/school_classes/upgrade_license_button/da.yml": 1234,
	"./components/school_classes/upgrade_license_button/en.yml": 57278,
	"./components/school_classes/upgrade_license_button/no.yml": 10718,
	"./components/school_classes/upgrade_license_button/se.yml": 2679,
	"./components/school_contact_requests/contact_my_school_button/da.yml": 8635,
	"./components/school_contact_requests/contact_my_school_button/en.yml": 65899,
	"./components/school_contact_requests/contact_my_school_button/no.yml": 80939,
	"./components/school_contact_requests/contact_my_school_button/se.yml": 1518,
	"./components/school_roles/change_role_modal/da.yml": 38471,
	"./components/school_roles/change_role_modal/en.yml": 3087,
	"./components/school_roles/change_role_modal/no.yml": 19519,
	"./components/school_roles/change_role_modal/se.yml": 67146,
	"./components/school_roles/new_role_modal/da.yml": 95453,
	"./components/school_roles/new_role_modal/en.yml": 83481,
	"./components/school_roles/new_role_modal/no.yml": 21045,
	"./components/school_roles/new_role_modal/se.yml": 97260,
	"./components/school_roles/remove_role_modal/da.yml": 63799,
	"./components/school_roles/remove_role_modal/en.yml": 7327,
	"./components/school_roles/remove_role_modal/no.yml": 15247,
	"./components/school_roles/remove_role_modal/se.yml": 87834,
	"./components/school_roles/user_circle/options_button/da.yml": 22962,
	"./components/school_roles/user_circle/options_button/en.yml": 74558,
	"./components/school_roles/user_circle/options_button/no.yml": 24894,
	"./components/school_roles/user_circle/options_button/se.yml": 66935,
	"./components/schools/current_schools/da.yml": 18650,
	"./components/schools/current_schools/en.yml": 30806,
	"./components/schools/current_schools/no.yml": 24166,
	"./components/schools/current_schools/se.yml": 77471,
	"./components/score_factor_groups/mood_bar_chart/da.yml": 48777,
	"./components/score_factor_groups/mood_bar_chart/en.yml": 32813,
	"./components/score_factor_groups/mood_bar_chart/no.yml": 15705,
	"./components/score_factor_groups/mood_bar_chart/se.yml": 20952,
	"./components/score_factor_groups/mood_simple_line_chart/da.yml": 81829,
	"./components/score_factor_groups/mood_simple_line_chart/en.yml": 16369,
	"./components/score_factor_groups/mood_simple_line_chart/no.yml": 76317,
	"./components/score_factor_groups/mood_simple_line_chart/se.yml": 49844,
	"./components/score_factors/mood_development_line_chart/da.yml": 40854,
	"./components/score_factors/mood_development_line_chart/en.yml": 31002,
	"./components/score_factors/mood_development_line_chart/no.yml": 66346,
	"./components/score_factors/mood_development_line_chart/se.yml": 55515,
	"./components/subscriptions/start_unicorn_user_trial_button/da.yml": 26819,
	"./components/subscriptions/start_unicorn_user_trial_button/en.yml": 6051,
	"./components/subscriptions/start_unicorn_user_trial_button/no.yml": 34227,
	"./components/subscriptions/start_unicorn_user_trial_button/se.yml": 82710,
	"./components/surveys/clone_button/da.yml": 26719,
	"./components/surveys/clone_button/en.yml": 11511,
	"./components/surveys/clone_button/no.yml": 59735,
	"./components/surveys/clone_button/se.yml": 76066,
	"./components/surveys/layout/da.yml": 71927,
	"./components/surveys/layout/en.yml": 98623,
	"./components/surveys/layout/no.yml": 13871,
	"./components/surveys/layout/se.yml": 38042,
	"./components/surveys/surveys/copy_step_button/da.yml": 45268,
	"./components/surveys/surveys/copy_step_button/en.yml": 12284,
	"./components/surveys/surveys/copy_step_button/no.yml": 61568,
	"./components/surveys/surveys/copy_step_button/se.yml": 56725,
	"./components/text_keys/partial/da.yml": 8121,
	"./components/text_keys/partial/en.yml": 38909,
	"./components/text_keys/partial/no.yml": 2633,
	"./components/text_keys/partial/se.yml": 41448,
	"./components/user/admin/school_classes/edit/teachers_select/da.yml": 78678,
	"./components/user/admin/school_classes/edit/teachers_select/en.yml": 76986,
	"./components/user/admin/school_classes/edit/teachers_select/no.yml": 81706,
	"./components/user/admin/school_classes/edit/teachers_select/se.yml": 73211,
	"./components/user/admin/school_classes/index/user_circle/options_button/da.yml": 13154,
	"./components/user/admin/school_classes/index/user_circle/options_button/en.yml": 86574,
	"./components/user/admin/school_classes/index/user_circle/options_button/no.yml": 29550,
	"./components/user/admin/school_classes/index/user_circle/options_button/se.yml": 21159,
	"./components/user/class_profile/overlay/da.yml": 98284,
	"./components/user/class_profile/overlay/en.yml": 51300,
	"./components/user/class_profile/overlay/no.yml": 40472,
	"./components/user/class_profile/overlay/se.yml": 64269,
	"./components/user/class_status/overlay/da.yml": 59219,
	"./components/user/class_status/overlay/en.yml": 39955,
	"./components/user/class_status/overlay/no.yml": 61539,
	"./components/user/class_status/overlay/se.yml": 45478,
	"./components/user/class_status/row/da.yml": 66987,
	"./components/user/class_status/row/en.yml": 68667,
	"./components/user/class_status/row/no.yml": 59,
	"./components/user/class_status/row/se.yml": 2686,
	"./components/user/dashboard/date_header/da.yml": 49446,
	"./components/user/dashboard/date_header/en.yml": 67914,
	"./components/user/dashboard/date_header/no.yml": 79706,
	"./components/user/dashboard/date_header/se.yml": 84907,
	"./components/user/dashboard/week_bar/da.yml": 65024,
	"./components/user/dashboard/week_bar/en.yml": 19520,
	"./components/user/dashboard/week_bar/no.yml": 8948,
	"./components/user/dashboard/week_bar/se.yml": 3009,
	"./components/user/dashboard/welcome_message/da.yml": 25042,
	"./components/user/dashboard/welcome_message/en.yml": 44574,
	"./components/user/dashboard/welcome_message/no.yml": 30974,
	"./components/user/dashboard/welcome_message/se.yml": 94871,
	"./components/user/insights/top_score_factor/da.yml": 62803,
	"./components/user/insights/top_score_factor/en.yml": 90739,
	"./components/user/insights/top_score_factor/no.yml": 19651,
	"./components/user/insights/top_score_factor/se.yml": 22886,
	"./components/user/school_class_courses/show/course_module_box/da.yml": 7956,
	"./components/user/school_class_courses/show/course_module_box/en.yml": 14620,
	"./components/user/school_class_courses/show/course_module_box/no.yml": 88192,
	"./components/user/school_class_courses/show/course_module_box/se.yml": 36373,
	"./components/user/school_classes/digital_class_room/recommended/da.yml": 52678,
	"./components/user/school_classes/digital_class_room/recommended/en.yml": 78474,
	"./components/user/school_classes/digital_class_room/recommended/no.yml": 70586,
	"./components/user/school_classes/digital_class_room/recommended/se.yml": 95691,
	"./components/user/school_classes/digital_class_room/strategies/da.yml": 13226,
	"./components/user/school_classes/digital_class_room/strategies/en.yml": 28966,
	"./components/user/school_classes/digital_class_room/strategies/no.yml": 17494,
	"./components/user/school_classes/digital_class_room/strategies/se.yml": 1295,
	"./components/user/unicorn/analysis_overlay/da.yml": 66843,
	"./components/user/unicorn/analysis_overlay/en.yml": 24107,
	"./components/user/unicorn/analysis_overlay/no.yml": 39147,
	"./components/user/unicorn/analysis_overlay/se.yml": 43374,
	"./components/user/unicorn/count_chart/da.yml": 98982,
	"./components/user/unicorn/count_chart/en.yml": 49514,
	"./components/user/unicorn/count_chart/no.yml": 20794,
	"./components/user/unicorn/count_chart/se.yml": 43787,
	"./components/user/unicorn/courses_overlay/da.yml": 12139,
	"./components/user/unicorn/courses_overlay/en.yml": 93435,
	"./components/user/unicorn/courses_overlay/no.yml": 84635,
	"./components/user/unicorn/courses_overlay/se.yml": 5054,
	"./components/user/unicorn/frequency_factors/da.yml": 82043,
	"./components/user/unicorn/frequency_factors/en.yml": 39307,
	"./components/user/unicorn/frequency_factors/no.yml": 70699,
	"./components/user/unicorn/frequency_factors/se.yml": 74926,
	"./components/user/unicorn/overlay/da.yml": 46206,
	"./components/user/unicorn/overlay/en.yml": 61842,
	"./components/user/unicorn/overlay/no.yml": 99826,
	"./components/user/unicorn/overlay/se.yml": 37699,
	"./components/user/unicorn/profile_box/da.yml": 78953,
	"./components/user/unicorn/profile_box/en.yml": 79341,
	"./components/user/unicorn/profile_box/no.yml": 45881,
	"./components/user/unicorn/profile_box/se.yml": 67480,
	"./components/user/unicorn/subscription_expired_overlay/da.yml": 47602,
	"./components/user/unicorn/subscription_expired_overlay/en.yml": 67134,
	"./components/user/unicorn/subscription_expired_overlay/no.yml": 53534,
	"./components/user/unicorn/subscription_expired_overlay/se.yml": 17431,
	"./components/user/unicorn/unicorn_effects/da.yml": 28155,
	"./components/user/unicorn/unicorn_effects/en.yml": 85419,
	"./components/user/unicorn/unicorn_effects/no.yml": 33643,
	"./components/user/unicorn/unicorn_effects/se.yml": 47214,
	"./components/user/unicorn/woof_before_brain_break_overlay/da.yml": 89953,
	"./components/user/unicorn/woof_before_brain_break_overlay/en.yml": 54645,
	"./components/user/unicorn/woof_before_brain_break_overlay/no.yml": 95217,
	"./components/user/unicorn/woof_before_brain_break_overlay/se.yml": 90800,
	"./components/users/accept_terms_hint/da.yml": 14508,
	"./components/users/accept_terms_hint/en.yml": 13604,
	"./components/users/accept_terms_hint/no.yml": 17048,
	"./components/users/accept_terms_hint/se.yml": 67693,
	"./components/users/circle_color_select/da.yml": 11457,
	"./components/users/circle_color_select/en.yml": 76149,
	"./components/users/circle_color_select/no.yml": 95761,
	"./components/users/circle_color_select/se.yml": 90576,
	"./components/users/confirmation/da.yml": 33113,
	"./components/users/confirmation/en.yml": 63901,
	"./components/users/confirmation/no.yml": 27625,
	"./components/users/confirmation/se.yml": 66440,
	"./components/users/forgot_password/da.yml": 64293,
	"./components/users/forgot_password/en.yml": 75281,
	"./components/users/forgot_password/no.yml": 701,
	"./components/users/forgot_password/se.yml": 27252,
	"./components/users/send_email_preview_button/da.yml": 16419,
	"./components/users/send_email_preview_button/en.yml": 45571,
	"./components/users/send_email_preview_button/no.yml": 147,
	"./components/users/send_email_preview_button/se.yml": 82806,
	"./components/users/sign_in/da.yml": 95317,
	"./components/users/sign_in/en.yml": 17377,
	"./components/users/sign_in/no.yml": 52013,
	"./components/users/sign_in/se.yml": 35524,
	"./components/users/sign_in_as_button/da.yml": 22895,
	"./components/users/sign_in_as_button/en.yml": 55975,
	"./components/users/sign_in_as_button/no.yml": 69575,
	"./components/users/sign_in_as_button/se.yml": 32370,
	"./components/users/sign_out/da.yml": 27290,
	"./components/users/sign_out/en.yml": 81974,
	"./components/users/sign_out/no.yml": 9958,
	"./components/users/sign_out/se.yml": 53375,
	"./notification/da.yml": 60863,
	"./notification/en.yml": 45655,
	"./notification/no.yml": 93879,
	"./notification/se.yml": 26562,
	"./routes/admin/account_schools/edit/da.yml": 95501,
	"./routes/admin/account_schools/edit/en.yml": 37225,
	"./routes/admin/account_schools/edit/no.yml": 42373,
	"./routes/admin/account_schools/edit/se.yml": 89820,
	"./routes/admin/account_users/edit/da.yml": 78518,
	"./routes/admin/account_users/edit/en.yml": 93178,
	"./routes/admin/account_users/edit/no.yml": 81546,
	"./routes/admin/account_users/edit/se.yml": 89403,
	"./routes/admin/accounts/account_schools/da.yml": 50449,
	"./routes/admin/accounts/account_schools/en.yml": 5253,
	"./routes/admin/accounts/account_schools/no.yml": 56193,
	"./routes/admin/accounts/account_schools/se.yml": 62368,
	"./routes/admin/accounts/account_users/da.yml": 80508,
	"./routes/admin/accounts/account_users/en.yml": 89172,
	"./routes/admin/accounts/account_users/no.yml": 79880,
	"./routes/admin/accounts/account_users/se.yml": 81277,
	"./routes/admin/accounts/edit/da.yml": 42044,
	"./routes/admin/accounts/edit/en.yml": 34356,
	"./routes/admin/accounts/edit/no.yml": 41416,
	"./routes/admin/accounts/edit/se.yml": 26461,
	"./routes/admin/accounts/index/da.yml": 16212,
	"./routes/admin/accounts/index/en.yml": 6524,
	"./routes/admin/accounts/index/no.yml": 80096,
	"./routes/admin/accounts/index/se.yml": 28277,
	"./routes/admin/brain_breaks/edit/da.yml": 67363,
	"./routes/admin/brain_breaks/edit/en.yml": 13475,
	"./routes/admin/brain_breaks/edit/no.yml": 40147,
	"./routes/admin/brain_breaks/edit/se.yml": 93238,
	"./routes/admin/brain_breaks/index/da.yml": 37677,
	"./routes/admin/brain_breaks/index/en.yml": 26377,
	"./routes/admin/brain_breaks/index/no.yml": 57701,
	"./routes/admin/brain_breaks/index/se.yml": 86140,
	"./routes/admin/challenges/edit/da.yml": 27774,
	"./routes/admin/challenges/edit/en.yml": 27954,
	"./routes/admin/challenges/edit/se.yml": 2307,
	"./routes/admin/challenges/index/da.yml": 35614,
	"./routes/admin/challenges/index/en.yml": 35794,
	"./routes/admin/challenges/index/se.yml": 10147,
	"./routes/admin/check_ins/edit/da.yml": 3271,
	"./routes/admin/check_ins/edit/en.yml": 63279,
	"./routes/admin/check_ins/edit/se.yml": 48298,
	"./routes/admin/check_ins/index/da.yml": 67561,
	"./routes/admin/check_ins/index/en.yml": 14029,
	"./routes/admin/check_ins/index/no.yml": 80569,
	"./routes/admin/check_ins/index/se.yml": 86936,
	"./routes/admin/class_steps/edit/da.yml": 25666,
	"./routes/admin/class_steps/edit/en.yml": 99086,
	"./routes/admin/class_steps/edit/no.yml": 58414,
	"./routes/admin/class_steps/edit/se.yml": 33671,
	"./routes/admin/class_steps/index/da.yml": 26906,
	"./routes/admin/class_steps/index/en.yml": 35510,
	"./routes/admin/class_steps/index/no.yml": 36422,
	"./routes/admin/class_steps/index/se.yml": 9023,
	"./routes/admin/content_piece_types/edit/da.yml": 8648,
	"./routes/admin/content_piece_types/edit/en.yml": 32696,
	"./routes/admin/content_piece_types/edit/no.yml": 5276,
	"./routes/admin/content_piece_types/edit/se.yml": 24105,
	"./routes/admin/content_piece_types/index/da.yml": 13064,
	"./routes/admin/content_piece_types/index/en.yml": 31224,
	"./routes/admin/content_piece_types/index/no.yml": 87452,
	"./routes/admin/content_piece_types/index/se.yml": 54921,
	"./routes/admin/course_group_course/edit/da.yml": 28671,
	"./routes/admin/course_group_course/edit/en.yml": 29815,
	"./routes/admin/course_group_course/edit/no.yml": 75479,
	"./routes/admin/course_group_course/edit/se.yml": 41954,
	"./routes/admin/course_group_course_score_factors/edit/da.yml": 12909,
	"./routes/admin/course_group_course_score_factors/edit/en.yml": 6217,
	"./routes/admin/course_groups/course_group_courses/da.yml": 83572,
	"./routes/admin/course_groups/course_group_courses/en.yml": 50588,
	"./routes/admin/course_groups/course_group_courses/no.yml": 7424,
	"./routes/admin/course_groups/course_group_courses/se.yml": 9525,
	"./routes/admin/course_groups/edit/da.yml": 75692,
	"./routes/admin/course_groups/edit/en.yml": 80292,
	"./routes/admin/course_groups/edit/no.yml": 52504,
	"./routes/admin/course_groups/edit/se.yml": 89261,
	"./routes/admin/course_groups/index/da.yml": 31780,
	"./routes/admin/course_groups/index/en.yml": 34092,
	"./routes/admin/course_groups/index/no.yml": 47568,
	"./routes/admin/course_groups/index/se.yml": 58021,
	"./routes/admin/course_modules/edit/da.yml": 37437,
	"./routes/admin/course_modules/edit/en.yml": 74169,
	"./routes/admin/course_modules/edit/no.yml": 90773,
	"./routes/admin/course_modules/edit/se.yml": 92940,
	"./routes/admin/courses/course_modules/da.yml": 70947,
	"./routes/admin/courses/course_modules/en.yml": 50179,
	"./routes/admin/courses/course_modules/no.yml": 78355,
	"./routes/admin/courses/course_modules/se.yml": 26838,
	"./routes/admin/courses/edit/da.yml": 83504,
	"./routes/admin/courses/edit/en.yml": 88976,
	"./routes/admin/courses/edit/no.yml": 44292,
	"./routes/admin/courses/edit/se.yml": 67473,
	"./routes/admin/courses/index/da.yml": 42016,
	"./routes/admin/courses/index/en.yml": 96512,
	"./routes/admin/courses/index/no.yml": 85940,
	"./routes/admin/courses/index/se.yml": 96353,
	"./routes/admin/crm/index/da.yml": 35982,
	"./routes/admin/crm/index/en.yml": 5954,
	"./routes/admin/crm/index/no.yml": 72226,
	"./routes/admin/crm/index/se.yml": 48947,
	"./routes/admin/dashboard/da.yml": 16349,
	"./routes/admin/dashboard/en.yml": 79257,
	"./routes/admin/dashboard/no.yml": 65237,
	"./routes/admin/dashboard/se.yml": 52908,
	"./routes/admin/dialogues/edit/da.yml": 76515,
	"./routes/admin/dialogues/edit/en.yml": 69603,
	"./routes/admin/dialogues/edit/no.yml": 41747,
	"./routes/admin/dialogues/edit/se.yml": 6838,
	"./routes/admin/email_templates/edit/da.yml": 89378,
	"./routes/admin/email_templates/edit/en.yml": 51118,
	"./routes/admin/email_templates/edit/no.yml": 45422,
	"./routes/admin/email_templates/edit/se.yml": 90055,
	"./routes/admin/email_templates/index/da.yml": 25786,
	"./routes/admin/email_templates/index/en.yml": 37942,
	"./routes/admin/email_templates/index/no.yml": 31302,
	"./routes/admin/email_templates/index/se.yml": 84607,
	"./routes/admin/email_templates/previews/edit/da.yml": 77584,
	"./routes/admin/email_templates/previews/edit/en.yml": 92848,
	"./routes/admin/email_templates/previews/edit/no.yml": 76452,
	"./routes/admin/email_templates/previews/edit/se.yml": 78673,
	"./routes/admin/email_templates/previews/index/da.yml": 85056,
	"./routes/admin/email_templates/previews/index/en.yml": 88864,
	"./routes/admin/email_templates/previews/index/no.yml": 78292,
	"./routes/admin/email_templates/previews/index/se.yml": 14881,
	"./routes/admin/email_templates/previews/show/da.yml": 8569,
	"./routes/admin/email_templates/previews/show/en.yml": 47133,
	"./routes/admin/email_templates/previews/show/no.yml": 78793,
	"./routes/admin/email_templates/previews/show/se.yml": 93928,
	"./routes/admin/error_testing/da.yml": 37248,
	"./routes/admin/error_testing/en.yml": 91744,
	"./routes/admin/error_testing/no.yml": 81172,
	"./routes/admin/error_testing/se.yml": 75233,
	"./routes/admin/newsletter_templates/edit/da.yml": 35829,
	"./routes/admin/newsletter_templates/edit/en.yml": 6753,
	"./routes/admin/newsletter_templates/edit/no.yml": 2861,
	"./routes/admin/newsletter_templates/edit/se.yml": 24900,
	"./routes/admin/newsletter_templates/index/da.yml": 78383,
	"./routes/admin/newsletter_templates/index/en.yml": 11463,
	"./routes/admin/newsletter_templates/index/no.yml": 25063,
	"./routes/admin/newsletter_templates/index/se.yml": 87858,
	"./routes/admin/newsletter_templates/table_searches/edit/da.yml": 57901,
	"./routes/admin/newsletter_templates/table_searches/edit/en.yml": 51209,
	"./routes/admin/newsletter_templates/table_searches/edit/no.yml": 5381,
	"./routes/admin/newsletter_templates/table_searches/edit/se.yml": 26652,
	"./routes/admin/newsletter_templates/table_searches/index/da.yml": 6007,
	"./routes/admin/newsletter_templates/table_searches/index/en.yml": 65887,
	"./routes/admin/newsletter_templates/table_searches/index/no.yml": 81359,
	"./routes/admin/newsletter_templates/table_searches/index/se.yml": 34042,
	"./routes/admin/notificationTypes/notification_type_actions/da.yml": 1142,
	"./routes/admin/notificationTypes/notification_type_actions/en.yml": 52762,
	"./routes/admin/notificationTypes/notification_type_actions/no.yml": 91658,
	"./routes/admin/notificationTypes/notification_type_actions/se.yml": 20251,
	"./routes/admin/notificationTypes/notification_type_audit_triggers/da.yml": 83642,
	"./routes/admin/notificationTypes/notification_type_audit_triggers/en.yml": 38326,
	"./routes/admin/notificationTypes/notification_type_audit_triggers/no.yml": 66310,
	"./routes/admin/notificationTypes/notification_type_audit_triggers/se.yml": 9727,
	"./routes/admin/notification_type_actions/edit/da.yml": 14030,
	"./routes/admin/notification_type_actions/edit/en.yml": 10178,
	"./routes/admin/notification_type_actions/edit/no.yml": 61954,
	"./routes/admin/notification_type_actions/edit/se.yml": 14995,
	"./routes/admin/notification_type_audit_triggers/edit/da.yml": 16760,
	"./routes/admin/notification_type_audit_triggers/edit/en.yml": 91016,
	"./routes/admin/notification_type_audit_triggers/edit/no.yml": 70956,
	"./routes/admin/notification_type_audit_triggers/edit/se.yml": 91065,
	"./routes/admin/notification_types/edit/da.yml": 18011,
	"./routes/admin/notification_types/edit/en.yml": 35851,
	"./routes/admin/notification_types/edit/no.yml": 90315,
	"./routes/admin/notification_types/edit/se.yml": 6446,
	"./routes/admin/notification_types/index/da.yml": 57685,
	"./routes/admin/notification_types/index/en.yml": 12257,
	"./routes/admin/notification_types/index/no.yml": 39949,
	"./routes/admin/notification_types/index/se.yml": 46756,
	"./routes/admin/plans/edit/da.yml": 41346,
	"./routes/admin/plans/edit/en.yml": 43054,
	"./routes/admin/plans/edit/no.yml": 97390,
	"./routes/admin/plans/edit/se.yml": 91047,
	"./routes/admin/plans/index/da.yml": 32186,
	"./routes/admin/plans/index/en.yml": 10166,
	"./routes/admin/plans/index/no.yml": 33798,
	"./routes/admin/plans/index/se.yml": 46367,
	"./routes/admin/plans/subscriptions/da.yml": 62916,
	"./routes/admin/plans/subscriptions/en.yml": 88524,
	"./routes/admin/plans/subscriptions/no.yml": 40176,
	"./routes/admin/plans/subscriptions/se.yml": 773,
	"./routes/admin/school_class_group_class_steps/edit/da.yml": 83052,
	"./routes/admin/school_class_group_class_steps/edit/en.yml": 87652,
	"./routes/admin/school_class_group_class_steps/edit/no.yml": 59864,
	"./routes/admin/school_class_group_class_steps/edit/se.yml": 96621,
	"./routes/admin/school_class_groups/class_steps/da.yml": 63326,
	"./routes/admin/school_class_groups/class_steps/en.yml": 71058,
	"./routes/admin/school_class_groups/class_steps/no.yml": 65362,
	"./routes/admin/school_class_groups/class_steps/se.yml": 37859,
	"./routes/admin/school_class_groups/edit/da.yml": 2110,
	"./routes/admin/school_class_groups/edit/en.yml": 2290,
	"./routes/admin/school_class_groups/edit/no.yml": 92242,
	"./routes/admin/school_class_groups/edit/se.yml": 76643,
	"./routes/admin/school_class_groups/index/da.yml": 74750,
	"./routes/admin/school_class_groups/index/en.yml": 91282,
	"./routes/admin/school_class_groups/index/no.yml": 81234,
	"./routes/admin/school_class_groups/index/se.yml": 49283,
	"./routes/admin/school_class_roles/edit/da.yml": 88179,
	"./routes/admin/school_class_roles/edit/en.yml": 90035,
	"./routes/admin/school_class_roles/edit/no.yml": 62595,
	"./routes/admin/school_class_roles/edit/se.yml": 55590,
	"./routes/admin/school_classes/audits/da.yml": 49337,
	"./routes/admin/school_classes/audits/en.yml": 80125,
	"./routes/admin/school_classes/audits/no.yml": 43849,
	"./routes/admin/school_classes/audits/se.yml": 82664,
	"./routes/admin/school_classes/edit/da.yml": 35909,
	"./routes/admin/school_classes/edit/en.yml": 46897,
	"./routes/admin/school_classes/edit/no.yml": 18173,
	"./routes/admin/school_classes/edit/se.yml": 72468,
	"./routes/admin/school_classes/index/da.yml": 22719,
	"./routes/admin/school_classes/index/en.yml": 23863,
	"./routes/admin/school_classes/index/no.yml": 69527,
	"./routes/admin/school_classes/index/se.yml": 36002,
	"./routes/admin/school_classes/school_class_roles/da.yml": 33076,
	"./routes/admin/school_classes/school_class_roles/en.yml": 92,
	"./routes/admin/school_classes/school_class_roles/no.yml": 56928,
	"./routes/admin/school_classes/school_class_roles/se.yml": 59029,
	"./routes/admin/school_classes/subscriptions/da.yml": 73845,
	"./routes/admin/school_classes/subscriptions/en.yml": 44769,
	"./routes/admin/school_classes/subscriptions/no.yml": 56109,
	"./routes/admin/school_classes/subscriptions/se.yml": 40535,
	"./routes/admin/school_roles/edit/da.yml": 67970,
	"./routes/admin/school_roles/edit/en.yml": 96526,
	"./routes/admin/school_roles/edit/no.yml": 81486,
	"./routes/admin/school_roles/edit/se.yml": 17671,
	"./routes/admin/schools/account_schools/da.yml": 57750,
	"./routes/admin/schools/account_schools/en.yml": 47898,
	"./routes/admin/schools/account_schools/no.yml": 83242,
	"./routes/admin/schools/account_schools/se.yml": 72411,
	"./routes/admin/schools/audits/da.yml": 63925,
	"./routes/admin/schools/audits/en.yml": 85985,
	"./routes/admin/schools/audits/no.yml": 20621,
	"./routes/admin/schools/audits/se.yml": 4132,
	"./routes/admin/schools/edit/da.yml": 74593,
	"./routes/admin/schools/edit/en.yml": 39285,
	"./routes/admin/schools/edit/no.yml": 58897,
	"./routes/admin/schools/edit/se.yml": 53712,
	"./routes/admin/schools/index/da.yml": 90707,
	"./routes/admin/schools/index/en.yml": 27763,
	"./routes/admin/schools/index/no.yml": 91523,
	"./routes/admin/schools/index/se.yml": 76966,
	"./routes/admin/schools/subscriptions/da.yml": 3249,
	"./routes/admin/schools/subscriptions/en.yml": 27877,
	"./routes/admin/schools/subscriptions/no.yml": 67137,
	"./routes/admin/schools/subscriptions/se.yml": 93152,
	"./routes/admin/score_factor_group_score_factors/edit/da.yml": 66322,
	"./routes/admin/score_factor_group_score_factors/edit/en.yml": 34270,
	"./routes/admin/score_factor_group_score_factors/edit/no.yml": 68254,
	"./routes/admin/score_factor_group_score_factors/edit/se.yml": 26647,
	"./routes/admin/score_factor_groups/edit/da.yml": 12701,
	"./routes/admin/score_factor_groups/edit/en.yml": 12345,
	"./routes/admin/score_factor_groups/edit/no.yml": 96885,
	"./routes/admin/score_factor_groups/edit/se.yml": 2828,
	"./routes/admin/score_factor_groups/index/da.yml": 13927,
	"./routes/admin/score_factor_groups/index/en.yml": 57583,
	"./routes/admin/score_factor_groups/index/no.yml": 3423,
	"./routes/admin/score_factor_groups/index/se.yml": 42602,
	"./routes/admin/score_factor_groups_score_factors/da.yml": 29910,
	"./routes/admin/score_factor_groups_score_factors/en.yml": 20058,
	"./routes/admin/score_factor_groups_score_factors/no.yml": 55402,
	"./routes/admin/score_factor_groups_score_factors/se.yml": 44571,
	"./routes/admin/score_factors/edit/da.yml": 63513,
	"./routes/admin/score_factors/edit/en.yml": 94301,
	"./routes/admin/score_factors/edit/no.yml": 58025,
	"./routes/admin/score_factors/edit/se.yml": 96840,
	"./routes/admin/score_factors/index/da.yml": 61531,
	"./routes/admin/score_factors/index/en.yml": 18795,
	"./routes/admin/score_factors/index/no.yml": 67019,
	"./routes/admin/score_factors/index/se.yml": 96942,
	"./routes/admin/stylings/edit/da.yml": 41881,
	"./routes/admin/stylings/edit/en.yml": 49821,
	"./routes/admin/stylings/index/da.yml": 20507,
	"./routes/admin/stylings/index/en.yml": 54699,
	"./routes/admin/subscription_periods/edit/da.yml": 17584,
	"./routes/admin/subscription_periods/edit/en.yml": 32848,
	"./routes/admin/subscription_periods/edit/no.yml": 16452,
	"./routes/admin/subscription_periods/edit/se.yml": 35025,
	"./routes/admin/subscriptions/edit/da.yml": 33516,
	"./routes/admin/subscriptions/edit/en.yml": 86532,
	"./routes/admin/subscriptions/edit/no.yml": 75704,
	"./routes/admin/subscriptions/edit/se.yml": 99501,
	"./routes/admin/subscriptions/index/da.yml": 2564,
	"./routes/admin/subscriptions/index/en.yml": 79148,
	"./routes/admin/subscriptions/index/no.yml": 80272,
	"./routes/admin/subscriptions/index/se.yml": 82949,
	"./routes/admin/subscriptions/subscription_periods/da.yml": 3388,
	"./routes/admin/subscriptions/subscription_periods/en.yml": 148,
	"./routes/admin/subscriptions/subscription_periods/no.yml": 60232,
	"./routes/admin/subscriptions/subscription_periods/se.yml": 23101,
	"./routes/admin/survey_step_element_option_scores/edit/da.yml": 48610,
	"./routes/admin/survey_step_element_option_scores/edit/en.yml": 22030,
	"./routes/admin/survey_step_element_option_scores/edit/no.yml": 81358,
	"./routes/admin/survey_step_element_option_scores/edit/se.yml": 72967,
	"./routes/admin/survey_step_element_options/edit/da.yml": 67007,
	"./routes/admin/survey_step_element_options/edit/en.yml": 51799,
	"./routes/admin/survey_step_element_options/edit/no.yml": 13815,
	"./routes/admin/survey_step_element_options/edit/se.yml": 80290,
	"./routes/admin/survey_step_element_options/show/da.yml": 7066,
	"./routes/admin/survey_step_element_options/show/en.yml": 61750,
	"./routes/admin/survey_step_element_options/show/no.yml": 89734,
	"./routes/admin/survey_step_element_options/show/se.yml": 33151,
	"./routes/admin/survey_step_elements/edit/da.yml": 97433,
	"./routes/admin/survey_step_elements/edit/en.yml": 28221,
	"./routes/admin/survey_step_elements/edit/no.yml": 91945,
	"./routes/admin/survey_step_elements/edit/se.yml": 47112,
	"./routes/admin/survey_step_elements/preview/da.yml": 25239,
	"./routes/admin/survey_step_elements/preview/en.yml": 82559,
	"./routes/admin/survey_step_elements/preview/no.yml": 81679,
	"./routes/admin/survey_step_elements/preview/se.yml": 59770,
	"./routes/admin/survey_step_elements/show/da.yml": 32112,
	"./routes/admin/survey_step_elements/show/en.yml": 37584,
	"./routes/admin/survey_step_elements/show/no.yml": 92900,
	"./routes/admin/survey_step_elements/show/se.yml": 16081,
	"./routes/admin/survey_steps/edit/da.yml": 17906,
	"./routes/admin/survey_steps/edit/en.yml": 73950,
	"./routes/admin/survey_steps/edit/no.yml": 27390,
	"./routes/admin/survey_steps/edit/se.yml": 19351,
	"./routes/admin/survey_steps/show/da.yml": 3831,
	"./routes/admin/survey_steps/show/en.yml": 63711,
	"./routes/admin/survey_steps/show/no.yml": 62831,
	"./routes/admin/survey_steps/show/se.yml": 31866,
	"./routes/admin/surveys/edit/da.yml": 5751,
	"./routes/admin/surveys/edit/en.yml": 32447,
	"./routes/admin/surveys/edit/no.yml": 64047,
	"./routes/admin/surveys/edit/se.yml": 71866,
	"./routes/admin/surveys/index/da.yml": 61529,
	"./routes/admin/surveys/index/en.yml": 93,
	"./routes/admin/surveys/index/no.yml": 15401,
	"./routes/admin/surveys/index/se.yml": 46888,
	"./routes/admin/surveys/show/da.yml": 32162,
	"./routes/admin/surveys/show/en.yml": 93902,
	"./routes/admin/surveys/show/no.yml": 88206,
	"./routes/admin/surveys/show/se.yml": 32839,
	"./routes/admin/text_keys/translate/da.yml": 97244,
	"./routes/admin/text_keys/translate/en.yml": 94004,
	"./routes/admin/text_keys/translate/no.yml": 54088,
	"./routes/admin/text_keys/translate/se.yml": 16957,
	"./routes/admin/user_roles/edit/da.yml": 20587,
	"./routes/admin/user_roles/edit/en.yml": 5435,
	"./routes/admin/user_roles/edit/no.yml": 53659,
	"./routes/admin/user_roles/edit/se.yml": 74078,
	"./routes/admin/users/audits/da.yml": 59746,
	"./routes/admin/users/audits/en.yml": 61454,
	"./routes/admin/users/audits/no.yml": 99438,
	"./routes/admin/users/audits/se.yml": 9447,
	"./routes/admin/users/dialogue/da.yml": 16548,
	"./routes/admin/users/dialogue/en.yml": 18860,
	"./routes/admin/users/dialogue/no.yml": 32336,
	"./routes/admin/users/dialogue/se.yml": 42789,
	"./routes/admin/users/dialogues/da.yml": 63845,
	"./routes/admin/users/dialogues/en.yml": 74833,
	"./routes/admin/users/dialogues/no.yml": 46109,
	"./routes/admin/users/dialogues/se.yml": 404,
	"./routes/admin/users/edit/da.yml": 88866,
	"./routes/admin/users/edit/en.yml": 34254,
	"./routes/admin/users/edit/no.yml": 28558,
	"./routes/admin/users/edit/se.yml": 89543,
	"./routes/admin/users/index/da.yml": 96250,
	"./routes/admin/users/index/en.yml": 8406,
	"./routes/admin/users/index/no.yml": 1766,
	"./routes/admin/users/index/se.yml": 55071,
	"./routes/admin/users/school_class_roles/da.yml": 55779,
	"./routes/admin/users/school_class_roles/en.yml": 35011,
	"./routes/admin/users/school_class_roles/no.yml": 79539,
	"./routes/admin/users/school_class_roles/se.yml": 11670,
	"./routes/admin/users/school_roles/da.yml": 29216,
	"./routes/admin/users/school_roles/en.yml": 36128,
	"./routes/admin/users/school_roles/no.yml": 25556,
	"./routes/admin/users/school_roles/se.yml": 89889,
	"./routes/admin/users/subscriptions/da.yml": 57316,
	"./routes/admin/users/subscriptions/en.yml": 17548,
	"./routes/admin/users/subscriptions/no.yml": 35024,
	"./routes/admin/users/subscriptions/se.yml": 37701,
	"./routes/admin/users/user_roles/da.yml": 75859,
	"./routes/admin/users/user_roles/en.yml": 77715,
	"./routes/admin/users/user_roles/no.yml": 33923,
	"./routes/admin/users/user_roles/se.yml": 26918,
	"./routes/front/accounts/created/da.yml": 98952,
	"./routes/front/accounts/created/en.yml": 17112,
	"./routes/front/accounts/created/no.yml": 73340,
	"./routes/front/accounts/created/se.yml": 40809,
	"./routes/front/accounts/new/da.yml": 32062,
	"./routes/front/accounts/new/en.yml": 39794,
	"./routes/front/accounts/new/no.yml": 34098,
	"./routes/front/accounts/new/se.yml": 6595,
	"./routes/front/school_class_invitations/accept/da.yml": 24752,
	"./routes/front/school_class_invitations/accept/en.yml": 30224,
	"./routes/front/school_class_invitations/accept/no.yml": 85540,
	"./routes/front/school_class_invitations/accept/se.yml": 8721,
	"./routes/front/users/apply_forgotten_password_request/da.yml": 64323,
	"./routes/front/users/apply_forgotten_password_request/en.yml": 43555,
	"./routes/front/users/apply_forgotten_password_request/no.yml": 71731,
	"./routes/front/users/apply_forgotten_password_request/se.yml": 20214,
	"./routes/front/users/forgot_password/da.yml": 69695,
	"./routes/front/users/forgot_password/en.yml": 54487,
	"./routes/front/users/forgot_password/no.yml": 2711,
	"./routes/front/users/forgot_password/se.yml": 35394,
	"./routes/front/welcome/da.yml": 37873,
	"./routes/front/welcome/en.yml": 11525,
	"./routes/front/welcome/no.yml": 12993,
	"./routes/front/welcome/se.yml": 61696,
	"./routes/play/school_class_check_ins/team_surveys/completed/da.yml": 21321,
	"./routes/play/school_class_check_ins/team_surveys/completed/en.yml": 13357,
	"./routes/play/school_class_check_ins/team_surveys/completed/no.yml": 72121,
	"./routes/play/school_class_check_ins/team_surveys/completed/se.yml": 99224,
	"./routes/play/welcome/da.yml": 38862,
	"./routes/play/welcome/en.yml": 92482,
	"./routes/play/welcome/no.yml": 75106,
	"./routes/play/welcome/se.yml": 51827,
	"./routes/user/admin/school_classes/da.yml": 23906,
	"./routes/user/admin/school_classes/edit/da.yml": 27675,
	"./routes/user/admin/school_classes/edit/en.yml": 31019,
	"./routes/user/admin/school_classes/edit/no.yml": 36715,
	"./routes/user/admin/school_classes/edit/se.yml": 66638,
	"./routes/user/admin/school_classes/en.yml": 25614,
	"./routes/user/admin/school_classes/no.yml": 63598,
	"./routes/user/admin/school_classes/roles/edit/da.yml": 20441,
	"./routes/user/admin/school_classes/roles/edit/en.yml": 28381,
	"./routes/user/admin/school_classes/roles/edit/no.yml": 71433,
	"./routes/user/admin/school_classes/roles/edit/se.yml": 36648,
	"./routes/user/admin/school_classes/roles/index/da.yml": 94011,
	"./routes/user/admin/school_classes/roles/index/en.yml": 11851,
	"./routes/user/admin/school_classes/roles/index/no.yml": 66315,
	"./routes/user/admin/school_classes/roles/index/se.yml": 82446,
	"./routes/user/admin/school_classes/se.yml": 73607,
	"./routes/user/admin/users/da.yml": 82343,
	"./routes/user/admin/users/en.yml": 25999,
	"./routes/user/admin/users/no.yml": 71839,
	"./routes/user/admin/users/se.yml": 27370,
	"./routes/user/class_profile/da.yml": 5573,
	"./routes/user/class_profile/en.yml": 68145,
	"./routes/user/class_profile/no.yml": 4797,
	"./routes/user/class_profile/se.yml": 85268,
	"./routes/user/class_status/da.yml": 46466,
	"./routes/user/class_status/en.yml": 8206,
	"./routes/user/class_status/no.yml": 2510,
	"./routes/user/class_status/se.yml": 47143,
	"./routes/user/courses/show/da.yml": 91275,
	"./routes/user/courses/show/en.yml": 92955,
	"./routes/user/courses/show/no.yml": 78267,
	"./routes/user/courses/show/se.yml": 26974,
	"./routes/user/dashboard/da.yml": 35063,
	"./routes/user/dashboard/en.yml": 78591,
	"./routes/user/dashboard/no.yml": 94063,
	"./routes/user/dashboard/se.yml": 63098,
	"./routes/user/insights/da.yml": 97936,
	"./routes/user/insights/en.yml": 848,
	"./routes/user/insights/no.yml": 7748,
	"./routes/user/insights/se.yml": 95697,
	"./routes/user/profile/da.yml": 6966,
	"./routes/user/profile/en.yml": 58586,
	"./routes/user/profile/no.yml": 97482,
	"./routes/user/profile/se.yml": 26075,
	"./routes/user/school_class_check_ins/lobby/da.yml": 96089,
	"./routes/user/school_class_check_ins/lobby/en.yml": 57034,
	"./routes/user/school_class_check_ins/lobby/no.yml": 66313,
	"./routes/user/school_class_check_ins/lobby/se.yml": 97800,
	"./routes/user/school_class_check_ins/user_lobby/da.yml": 63867,
	"./routes/user/school_class_check_ins/user_lobby/en.yml": 21131,
	"./routes/user/school_class_check_ins/user_lobby/no.yml": 69355,
	"./routes/user/school_class_check_ins/user_lobby/se.yml": 82926,
	"./routes/user/school_class_course_modules/show/da.yml": 8724,
	"./routes/user/school_class_course_modules/show/en.yml": 18268,
	"./routes/user/school_class_course_modules/show/no.yml": 92064,
	"./routes/user/school_class_course_modules/show/se.yml": 51637,
	"./routes/user/school_class_courses/show/da.yml": 90865,
	"./routes/user/school_class_courses/show/en.yml": 45669,
	"./routes/user/school_class_courses/show/no.yml": 96609,
	"./routes/user/school_class_courses/show/se.yml": 2784,
	"./routes/user/school_classes/digital_class_room/da.yml": 65388,
	"./routes/user/school_classes/digital_class_room/en.yml": 18404,
	"./routes/user/school_classes/digital_class_room/no.yml": 7576,
	"./routes/user/school_classes/digital_class_room/se.yml": 31373,
	"./routes/user/school_classes/edit/da.yml": 72295,
	"./routes/user/school_classes/edit/en.yml": 23503,
	"./routes/user/school_classes/edit/no.yml": 42495,
	"./routes/user/school_classes/edit/se.yml": 24650,
	"./routes/user/school_classes/insights/da.yml": 294,
	"./routes/user/school_classes/insights/en.yml": 26090,
	"./routes/user/school_classes/insights/no.yml": 34554,
	"./routes/user/school_classes/insights/se.yml": 43307,
	"./routes/user/school_classes/roles/invite/da.yml": 75900,
	"./routes/user/school_classes/roles/invite/en.yml": 73268,
	"./routes/user/school_classes/roles/invite/no.yml": 81768,
	"./routes/user/school_classes/roles/invite/se.yml": 34749,
	"./routes/user/unicorn/da.yml": 77151,
	"./routes/user/unicorn/en.yml": 65943,
	"./routes/user/unicorn/no.yml": 23959,
	"./routes/user/unicorn/se.yml": 40290,
	"./routes/user/unsubscribed/da.yml": 14674,
	"./routes/user/unsubscribed/en.yml": 34206,
	"./routes/user/unsubscribed/no.yml": 20606,
	"./routes/user/unsubscribed/se.yml": 84503,
	"./routes/users/resend_confirmation_email/da.yml": 4456,
	"./routes/users/resend_confirmation_email/en.yml": 28504,
	"./routes/users/resend_confirmation_email/no.yml": 84732,
	"./routes/users/resend_confirmation_email/se.yml": 3561,
	"./shared/da.yml": 40517,
	"./shared/en.yml": 51505,
	"./shared/no.yml": 76925,
	"./shared/se.yml": 3476,
	"./user/school_classes/digital_class_room/da.yml": 52635,
	"./user/school_classes/digital_class_room/en.yml": 9899,
	"./user/school_classes/digital_class_room/no.yml": 41291,
	"./user/school_classes/digital_class_room/se.yml": 45518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70064;